import styled, { css } from 'styled-components';
import { Box, Avatar } from '@bechtel/gds';
export interface AvatarRegularStyledProps {
  hasImageUrl: boolean;
}
export const DashboardHeaderRowStyled = styled(Box).attrs({
  alignItems: { sm: 'center' },
})`
  /**TODO: Do we need design token for 12px in spacings */
  padding-top: ${({ theme }) => theme.fontSizes[300]};
  padding-bottom: ${({ theme }) => theme.fontSizes[300]};
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.16);
`;

export const DashboardHeaderHoverStyled = styled(Box).attrs({
})`
  position: relative
`;

export const AvatarRegularStyled = styled(Avatar)<AvatarRegularStyledProps>`
  border-width: 1px !important;
  ${({ theme, hasImageUrl }) => css`
    border-color: ${theme.colors.white};
    background-color: ${hasImageUrl ? theme.colors.white : theme.colors.grey[200]};
  `}
`;

